"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var WarningIcon = function WarningIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 60 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "30",
    cy: "30",
    r: "30",
    fill: "#DE4A30"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 34V19",
    stroke: "white",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 41L30 40",
    stroke: "white",
    strokeWidth: "3",
    strokeLinecap: "round"
  }));
};
var _default = WarningIcon;
exports.default = _default;